import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { HashLink } from 'react-router-hash-link'
import { createGlobalStyle } from 'styled-components'
import styled from 'styled-components'
import { CateIcon } from '../../layouts/app/styles'
import { userStore, categoryStore } from '../../stores/store'

const AsideMenu = observer(() => {
    const [active, setActive] = useState(null)

    return (
        <AsideWrap>
            <GlobalStyle />
            <Content className="header_component_asidemenu_content">
                <Top>
                    <Closed to='#' className="header_component_asidemenu_closed">
                        <i className="icon-ic_optclose" />
                    </Closed>
                    <div className="login_name">
                        {userStore.isLogin ? (
                            <><b>{userStore.user?.user_name}</b>님</>
                        ) : (
                            !userStore.isLogined ?
                                '-'
                                : (
                                    <a href={process.env.REACT_APP_SSO_URL}>로그인 해주세요 </a>
                                )
                        )}
                    </div>
                    <div className="button_group">
                        <a href={`https://my2.pping.${process.env.REACT_APP_TLD}/`}>마이쇼핑</a>
                        <a href={process.env.REACT_APP_CART_URL}>
                            장바구니
                            {userStore?.user?.cart.count ? <span className="num">{userStore?.user?.cart.count}</span> : ''}
                        </a>
                        <a href={`https://www2.pping.${process.env.REACT_APP_TLD}/item/list/recent`}>최근본상품</a>
                    </div>
                </Top>
                <Cate size={2.88} className="header_component_asidemenu_cate">
                    <ul className="dep0_list">
                        {categoryStore.cate.map(v => (
                            <li className="dep0_item" key={v.cate_id}>
                                <button className="dep0_link" onClick={() => setActive(active === v.cate_id ? null : v.cate_id)}>
                                    <i className={`cate_icon_bg bg-${v.cate_id}`}></i>
                                    {v.cate_name.replace(/·/g, '/')}
                                    <i className={`icon-angle-${active === v.cate_id ? 'up' : 'down'} arr`} />
                                </button>
                                {(active === v.cate_id && v.child.length > 0) && (
                                    <ul className="dep1_list">
                                        {v.child.map(k => (
                                            <li className="dep1_item" key={k.cate_id}>
                                                <a href={`${process.env.REACT_APP_SHOPPING_URL}/list/${k.cate_id}`} className="dep1_link">
                                                    {k.cate_name}
                                                    <i className="icon-angle-right arr" />
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                </Cate>
                <Help href={process.env.REACT_APP_HELP_URL} className="header_component_asidemenu_help">
                    <i className="icon-ic_call" />고객센터
                </Help>
            </Content>
        </AsideWrap>
    )
})

const GlobalStyle = createGlobalStyle`
    body {
        height: 100%;
        min-height: 100%;
        overflow: hidden;
        touch-action: none;
    }
`

const AsideWrap = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: #fff;
    overflow-y: auto;
    overflow-x: hidden;
`
const Content = styled.div`
    height: 100%;
`
const Top = styled.div`
    height: 150px;
    background: #418ded;
    padding: 30px 0 0 20px;

    .login_name {
        margin: 0 0 20px;
        font-size: 22px;
        color: #fff;
        height: 33px;
        line-height: 33px;

        b {
            font-weight: 700
        }
    }
    .button_group {
        display: flex;
        height: 36px;

        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: calc(33% - 11px);
            height: 36px;
            border: 1px solid #fff;
            border-radius: 18px;
            color: #fff;
            font-size: 16px;
            position: relative;

            &:not(:first-of-type) {
                margin-left: 10px;
            }
            .num {
                position: absolute;
                font-size: 12px;
                color: #418ded;
                width: 20px;
                height: 20px;
                background: #fff;
                border-radius: 20px;
                line-height: 20px;
                text-align: center;
                top: -10px;
                right: 4px;
            }
        }
    }
`
const Closed = styled(HashLink)`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    color: #fff;
    background: none;
    border: 0px;
    font-size: 18px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
`
const Cate = styled(CateIcon)`
    min-height: calc(100% - 200px);

    .dep0_item {
        border-bottom: 1px solid #e5e5e5;
    }
    .dep0_link {
        position: relative;
        display: flex;
        border: 0;
        background: none;
        padding: 0 20px 0 64px;
        width: 100%;
        height: 51px;
        align-items: center;

        .cate_icon_bg {
            position: absolute;
            top: 26px;
            left: 32px;
            transform: translate(-50%, -50%);
        }
        .arr {
            position: absolute;
            top: 21px;
            right: 20px;
            width: 16px;
            height: 9px;
            font-size: 24px;
            line-height: 9px;
            color: #999;
        }
    }
    .dep1_list {
        padding: 18px 0;
        background: #f9f9f9;
    }
    .dep1_link {
        position: relative;
        display: flex;
        padding: 0 64px;
        height: 34px;
        align-items: center;
        color: #707070;

        .arr {
            position: absolute;
            top: 13px;
            right: 64px;
            width: 6px;
            height: 9px;
            font-size: 17px;
            line-height: 9px;
            color: #999;
        }
    }
`
const Help = styled.a`
    display: flex;
    background: #e5e5e5;
    height: 50px;
    justify-content: center;
    align-items: center;
    font-size: 15px;

    i {
        margin: 0 7px 0 0;
        font-size: 19px;
    }
`

export default AsideMenu



// WEBPACK FOOTER //
// ./src/m_header/pages/aside/aside_menu.js